import script from "./Machine.vue?vue&type=script&setup=true&lang=js"
export * from "./Machine.vue?vue&type=script&setup=true&lang=js"

import "./Machine.vue?vue&type=style&index=0&id=53477c5e&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53477c5e"]])

export default __exports__